import { useState } from "react";

const imgFolder = "./img/interior/";

const models = [
  {
    key: "m5",
    name: "M5",
    colors: [
      { key: "black", name: "Черный" },
      { key: "onix-brown", name: "Оникс коричневый" },
      { key: "ivory", name: "Слоновая кость" },
    ],
  },
];

function VehicleImage({ model, color }) {
  const imgName = `${model}/${color.key}.jpg`;

  return (
    <img
      className="car-interior-image"
      src={`${imgFolder}${imgName}`}
      alt={`M5, ${color.name}`}
    />
  );
}

function ModelSelector({ value, onModelClick }) {
  return (
    <button className="configurator-parameters-model" onClick={onModelClick}>
      {value}
    </button>
  );
}

export default function Interior() {
  const [modelSelected, setModel] = useState("m5");
  const [colorSelected, setColor] = useState(models[0].colors[0]);

  function onModelClick(modelClicked) {
    setModel(modelClicked);
  }

  function onColorClick(colorClicked) {
    setColor(colorClicked);
  }

  function ColorSelector({ value, onColorClick, colorSelected }) {
    const imgName = `m5_icons/${value}.png`;

    return (
      <img
        className={`configurator-parameters__color ${
          colorSelected.key === value ? "active" : ""
        }`}
        src={`${imgFolder}${imgName}`}
        alt={value}
        onClick={onColorClick}
      />
    );
  }

  return (
    <>
      <div className="configurator-preview">
        <VehicleImage model={modelSelected} color={colorSelected} />
      </div>

      <div className="configurator-parameters-wrapper">
        <div className="carCaption">{colorSelected.name}</div>
        <div className="configurator-parameters">
          {/* <div className="configurator-parameters-section, hidden">
              <ModelSelector value="M5-1" onModelClick={() => onModelClick("m5")} />
              <ModelSelector value="M5-2" onModelClick={() => onModelClick("m5")} />
            </div> */}
          <div className="configurator-parameters-section">
            {models[0].colors.map((color) => (
              <ColorSelector
                value={color.key}
                key={color.key}
                onColorClick={() => {
                  onColorClick(color);
                }}
                colorSelected={colorSelected}
              />
            ))}
          </div>
        </div>
        <div className="carCaption"></div>
      </div>
    </>
  );
}
